module.exports = __webpack_public_path__ + "img/talkmHead.6241c6aa.jpg";